"use client";

import { REFERRAL_CODE_STORAGE_KEY } from "@/common/const";
import { safeLocalStorageSetItem } from "@/util/safeLocalStorage";
import { useEffect } from "react";

export const getReferralCodeFromSearch = (search: string) => {
  if (!search) {
    return "";
  }

  const params = new URLSearchParams(search);
  return params.get("referral")?.trim() || "";
};

export const storeReferralCode = (code: string) => {
  if (!code) {
    return false;
  }

  return safeLocalStorageSetItem(REFERRAL_CODE_STORAGE_KEY, code);
};

export function ReferralTracker() {
  useEffect(() => {
    const code = getReferralCodeFromSearch(window.location.search);
    storeReferralCode(code);
  }, []);

  return null;
}
